import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {AppService} from '../../appService';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Toast, ToastsManager} from 'ng2-toastr';
import {environment} from '../../../environments/environment';
import {ConfirmSaveComponent} from '../../confirm-dialog/confirm-save/confirm-save.component';
import {CrtmInstructionDialogComponent} from '../counselling-request-to-mentor/crtm-instruction-dialog/crtm-instruction-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-proctorial-request-to-mentor',
  templateUrl: './proctorial-request-to-mentor.component.html',
  styleUrls: ['./proctorial-request-to-mentor.component.css']
})
export class ProctorialRequestToMentorComponent implements OnInit {
  selectedSemesterForSave: any = '';
  selectedSemesterForSearch: any = '';
  studentId: any = '';
  meeting_reason: any = '';
  counselling_title: any = '';
  counselling_detail: any = '';
  pendingMeetingListFilter: any = '';
  completeMeetingListFilter: any = '';

  semesterList: any = [];
  pendingMeetingList: any = [];
  completedMeetingList: any = [];
  studentDetails: any = null;
  mentorDetails: any = null;
  submitData: any = {};

  // meetingReasonList: any = [
  //   {reason: 'Academic Discussion'},
  //   {reason: 'Personal Dialogue'},
  //   {reason: 'Career Building'},
  //   {reason: 'Motivational Talk'},
  //   {reason: 'Class Monitoring'},
  //   {reason: 'Registration'},
  //   {reason: 'Result'},
  //   {reason: 'Attendance'},
  //   {reason: 'Payment Due'},
  //   {reason: 'Extracurricular Activities'}
  // ];

  meetingReasonList: any = [
    {reason: 'Conflict'},
    {reason: 'Harassment'},
    {reason: 'Drug'},
    {reason: 'Cyber Bullying'},
    {reason: 'Ragging'},
    {reason: 'Bullying'},
    {reason: 'Extortion'},
    {reason: 'Theft'},
    {reason: 'Fraudulent Behavior'},
  ];



  constructor(private appService: AppService,
              private localStorage: LocalStorageService,
              private sessionStorage: SessionStorageService,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router, private httpClient: HttpClient, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr); }


  ngOnInit() {
    this.appService.hasAccessToken();
    this.getSemesterList();
  }


  getSemesterList() {
    const myParams = new HttpParams();
    this.httpClient.get(environment.apiUrl + 'studentCounselling/semesterList', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams
    }).subscribe(res => {
        // // console.log(res);
        this.semesterList = res;
      },
      msg => {
        console.error('error');
      }
    );
  }


  getStudentDetails() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'studentCounselling/studentDetails', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams})
      .subscribe(res => {
          // console.log(res);
          this.studentDetails = res;
          if (res != null) {
            this.toastr.success('Valid Student Id.', 'Success!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000); });
          }
          if (res == null) {
            this.toastr.error('Invalid Student Id!', 'Fail!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 3000);         });
          }
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
          this.toastr.error('Logout Failed!', 'Oops!!', {dismiss: 'click', showCloseButton: false, animate: 'flyLef'})
            .then((toast: Toast) => { setTimeout(() => {this.toastr.dismissToast(toast); }, 2000);
            });
        }
      );
  }

  getMentorDetails() {
    const myParams = new HttpParams().append('studentId', this.studentId);
    this.httpClient.get(environment.apiUrl + 'studentCounselling/mentorDetails', {
      headers: this.appService.getHeadersWithAccessToken(),
      params: myParams})
      .subscribe(res => {
          // console.log(res);
          this.mentorDetails = res;
          if (res != null) {
            this.toastr.success('Mentor Found for the Student.', 'Success!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000); });
          }
          if (res == null) {
            this.toastr.error('Mentor not set yet!', 'Fail!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 3000);         });
          }
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
        }
      );
  }

  clearData () {
    this.selectedSemesterForSave = '';
    this.studentId = '';
    this.studentDetails = null;
    this.mentorDetails = null;
    this.meeting_reason = '';
    this.counselling_title = '';
    this.counselling_detail = '';
  }



  saveRequestToProctorMeeting() {
    this.submitData = {
      semester_id: this.selectedSemesterForSave,
      student_id: this.studentDetails.student_id,
      mentor_teacher_id: this.mentorDetails.teacher_id,
      meeting_reason: this.meeting_reason,
      counselling_request_title: this.counselling_title,
      counselling_request_detail: this.counselling_detail,
    };
    // console.log(this.submitData);

    this.httpClient.post(environment.apiUrl + 'studentCounselling/proctorRequestToMentor/saveMeeting', this.submitData, { headers: this.appService.getHeadersWithAccessToken()})
      .subscribe(
        res => {
          // console.log('post response :' , res);
          if (res['status'] === 'success') {
            this.toastr.success('Counselling Saved Success!', 'Success!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000);     this.clearData();    });
          }
          if (res['status'] === 'failed') {
            this.toastr.error('Counselling Saved failed!', 'Fail!', {dismiss: 'click', showCloseButton: true,       animate: 'flyLef'})
              .then((toast: Toast) => {    setTimeout(() => {     this.toastr.dismissToast(toast);       }, 2000);         });
          }
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
          this.toastr.error('Logout Failed!', 'Oops!!', {dismiss: 'click', showCloseButton: false, animate: 'flyLef'})
            .then((toast: Toast) => { setTimeout(() => {this.toastr.dismissToast(toast); }, 2000);
            });
        }
      );
  }


  saveRequestToProctorMeetingWithConfirmation(): void {

    // console.log('opening dialog');

    const dialogRef = this.dialog.open(ConfirmSaveComponent, {
      width: 'auto',  data: {today: new Date()}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === undefined ) {
        // console.log("undefined not save");
      } else { // console.log("undefined not");
        if (result.confirmStatus === 'yes' ) {
          // console.log('save');
          this.saveRequestToProctorMeeting();
        }else {
          // console.log("not save");
        }
      }
    });
  }


  getPendingMeetingList() {
    const myParams = new HttpParams().append('semesterId', this.selectedSemesterForSearch);
    this.httpClient.get(environment.apiUrl + 'studentCounselling/proctorRequestToMentor/pendingMeetingList', { headers: this.appService.getHeadersWithAccessToken(), params: myParams })
      .subscribe(
        res => {
          // console.log('pending res' , res);
          this.pendingMeetingList = res;
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
        }
      );
  }

  getCompleteMeetingList() {
    const myParams = new HttpParams().append('semesterId', this.selectedSemesterForSearch);
    this.httpClient.get(environment.apiUrl + 'studentCounselling/proctorRequestToMentor/completeMeetingList', { headers: this.appService.getHeadersWithAccessToken(), params: myParams })
      .subscribe(
        res => {
          // console.log('res' , res);
          this.completedMeetingList = res;
        },
        msg => {
          console.error(`Error: ${msg.status} ${msg.statusText}`);
        }
      );
  }


  openCrtmInstructionDialog(): void {
    const dialogRef = this.dialog.open(CrtmInstructionDialogComponent, {
      width: '60%',
      height: 'auto',
      disableClose: false,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }
  // constructor() { }
  //
  // ngOnInit() {
  // }

}
